// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".9d0767bf9b1fe1e26c85d4de9210351b1f8ef8f7.chunk.js";
};